import { currentPage } from '../common/layout';
// import '../common/polymer/webcomponents-init';
import '../common/jquery-snap-scroll';
// import '../common/lot-linx-car';
// import { getM1FindVehicleEu, getM1FindVehicleUs } from '../common/shop/m1-find-vehicle-widget-loader';
import { getCoralCommentsCountUpdate } from '../common/utils/coral-requests-loader';


currentPage.pageInit = ($page, pageData, pageId) => {
  let currentEdition = document.body.dataset.edtn;

  $('.msnt-items-slider').snapScrollControl();
    
  $('.m1-model-anchors .m1-button').each((i, elem) => {
    const $elem = $(elem);
    const headerHeight = $('.m1-header-main').height();
    const scrollPadding = 16;

    $elem.on('click', (e) => {
      e.preventDefault();
      const $target = $($elem.attr('href'));

      if ($target.length) {
        $(document.scrollingElement).animate({"scrollTop": $target.offset().top - headerHeight - scrollPadding});
      }

      return false;
    });
  });

  if (currentEdition == 'it') {
    function setupToggleButton({
      buttonSelector, 
      itemsSelector, 
      itemsToShowMobile, 
      itemsToShowDesktop, 
      textShowMore, 
      textShowLess
    }) {
      const button = document.querySelector(buttonSelector);
      if (!button) return;
    
      const items = document.querySelectorAll(itemsSelector);
      const isMobile = window.innerWidth < 768;
      const itemsToShow = isMobile ? itemsToShowMobile : itemsToShowDesktop;
    
      if (!isMobile && itemsToShow === 'allItems') {
        items.forEach(el => el.classList.remove('hidden'));
        button.classList.add('hidden');
        return;
      }
    
      const shouldShowButton = items.length > itemsToShow;
    
      if (shouldShowButton) {
        button.classList.remove('hidden');
        button.classList.add('block');
    
        const elementsToHide = Array.from(items).slice(itemsToShow);
        elementsToHide.forEach(el => el.classList.add('hidden'));
    
        let expanded = false;
        button.addEventListener('click', () => {
          expanded = !expanded;
          elementsToHide.forEach(el => el.classList.toggle('hidden'));
    
          if (button.querySelector('.button-show-more') && button.querySelector('.button-show-less')) {
            button.querySelector('.button-show-more').classList.toggle('hidden');
            button.querySelector('.button-show-less').classList.toggle('hidden');
          } else {
            button.textContent = expanded ? textShowLess : textShowMore;
          }
        });
      } else {
        button.classList.add('hidden');
      }
    }
    
    setupToggleButton({
      buttonSelector: '#showMore',
      itemsSelector: '.submode-trims_item',
      itemsToShowMobile: 3,
      itemsToShowDesktop: 3,
      textShowMore: 'LEGGI DI PIÙ',
      textShowLess: 'Nascondi'
    });
    
    setupToggleButton({
      buttonSelector: '.submodel-trims-text-content .show-more',
      itemsSelector: '.submodel-trims-text-content p',
      itemsToShowMobile: 3,
      itemsToShowDesktop: 'allItems',
      textShowMore: 'LEGGI DI PIÙ',
      textShowLess: 'Nascondi'
    });
  }

  // getM1FindVehicleEu().then((api) => {
  //   api.m1FindVehicleEu();
  // });
  // getM1FindVehicleUs().then((api) => {
  //   api.m1FindVehicleUs();
  // });
  getCoralCommentsCountUpdate().then((api) => {
    api.coralCommentsCountUpdate();
  });
};
